import React, { Component } from "react";
import { Table, Button } from "antd";
import { PlusOutlined, PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

import { apiNotification } from "../../../../api/api-notification";
import { emitter } from "../../../../common/utils/emitter";
import { alert } from "../../../../common/utils/alert";

export class NotificationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
      isAddUser: false,
      typeOption: "create_new",
    };

    this.page = 1;

    this.customerTable = [
      {
        title: "",
        key: "index",
        dataIndex: "index",
        render: () => (
          <div style={{ display: " flex", justifyContent: "center" }}>
            <div className="circle"></div>
          </div>
        ),
      },
      {
        title: "Nội dung thông báo",
        dataIndex: "content",
        key: "content",
        render: (data) => <div style={{ textAlign: "left" }}>{data}</div>,
      },
      {
        title: "Thời gian",
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          const time_unix = moment(item).format("DD/MM/YYYY");
          return item ? <span>{time_unix}</span> : null;
        },
      },
    ];
  }

  componentDidMount() {
    this.getData(1);
  }

  getData = async (page) => {
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiNotification.getNotiList(page);
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.totalElements },
          () => {}
        );
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    this.getData(page);
  };

  render() {
    const { dataTable, total } = this.state;
    return (
      <>
        <div className="notification-table">
          <div
            style={{
              color: "#d20a30",
              paddingTop: "20px",
              fontSize: "1em",
              display: "flex",
              alignItems: "center",
            }}
          >
            Danh sách thông báo của tôi
          </div>
          <Table
            rowKey={(record) => record.id}
            style={{ width: "100%" }}
            dataSource={dataTable}
            pagination={{
              total,
              pageSize: 10,
              onChange: this.onChangePage,
              current: this.page,
            }}
            //pagination={false}
            scroll={{ x: true }}
            columns={this.customerTable}
          />
        </div>
      </>
    );
  }
}
